import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, Button, ComponentSync, LL_H_C, LL_V_L, openContent } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_EMInterface } from '@app/advisor-frontend';
import { ModuleFE_ProvideInfo } from '../../../modules/provide-info/ModuleFE_ProvideInfo.js';
import { asArray } from '@nu-art/ts-common';
import { Renderer_Score } from '../../panels/AdvisorPanel_NextSteps/Renderer_Score/Renderer_Score.js';
import { Component_ProtocolGraph } from '../next-steps/working-diagnosis/Component_ProtocolGraph/Component_ProtocolGraph.js';
import { PopUp_ProtocolGoTo } from '../../pop-ups/PopUp_ProtocolGoTo/PopUp_ProtocolGoTo.js';
import { PopUp_ProtocolDetails } from '../../pop-ups/PopUp_ProtocolDetails/PopUp_ProtocolDetails.js';
import './Component_ProtocolInfo.scss';
import { pathwayType_SingleState } from '@app/pathway-shared';
export class Component_ProtocolInfo extends ComponentSync {
    //######################### Life Cycle #########################
    __onProvideInfoContextChange = (latestContext) => this.reDeriveState();
    __onProvideInfoContextUpdate = (context) => {
        if (context.key === 'protocol')
            this.reDeriveState();
    };
    //## Listen on protocol changes to update the graph
    __onRuntimeProtocolsUpdated = (...params) => {
        const currentProtocolId = this.state.contextData?.protocolData.protocol._id;
        if (currentProtocolId && asArray(params[1]).find(p => p._id === currentProtocolId))
            this.reDeriveState();
    };
    deriveStateFromProps(nextProps, state) {
        const baseContext = ModuleFE_ProvideInfo.getCurrentProtocolContextData();
        state.contextData = baseContext ? { ...baseContext } : undefined;
        state.showDetails = ModuleFE_ProvideInfo.shouldShowDetailsOnOpen()
            || state.contextData?.protocolData.pathway.type === pathwayType_SingleState;
        return state;
    }
    //######################### Logic #########################
    hideDetails = () => {
        ModuleFE_ProvideInfo.clearShowDetailsOnOpen();
        this.setState({ showDetails: false });
    };
    toggleDetails = () => {
        if (this.state.showDetails)
            return this.hideDetails();
        const context = this.state.contextData;
        if (!context)
            return;
        this.setState({ showDetails: true });
    };
    openGoTo = (e) => {
        const context = this.state.contextData;
        if (!context)
            return;
        PopUp_ProtocolGoTo.show(e, { protocolData: context.protocolData });
    };
    //######################### Render #########################
    render() {
        const contextData = this.state.contextData;
        if (!contextData)
            return _jsx(LL_V_L, { className: 'protocol-info', children: _jsx("div", { className: 'protocol-info__no-data-message', children: "No underlying protocol context to display" }) });
        return _jsxs(LL_V_L, { className: 'protocol-info', children: [this.render_Scores(contextData), this.render_Graph(contextData), this.render_Actions(), this.render_Details()] });
    }
    render_Scores = (context) => {
        if (!context.protocolData.scoreData.length)
            return;
        return _jsx(LL_H_C, { className: 'protocol-info__scores', children: context.protocolData.scoreData.map(scoreData => {
                return _jsx(Renderer_Score, { scoreData: scoreData }, scoreData.getScoreReference().variableId);
            }) });
    };
    render_Graph = (context) => {
        if (context.protocolData.pathway.type === pathwayType_SingleState)
            return _jsx("div", { className: 'message', children: "No protocol map available for this diagnosis" });
        return _jsx(Component_ProtocolGraph, { context: context }, context.protocolData.protocol._id);
    };
    render_Actions = () => {
        return _jsxs(LL_H_C, { className: 'protocol-info__actions', children: [this.render_DetailsButton(), this.render_GoToButton()] });
    };
    render_DetailsButton = () => {
        const className = _className(this.state.showDetails && 'active');
        return _jsx(Button, { variant: 'header-button', className: className, onClick: this.toggleDetails, children: "Reasoning" });
    };
    render_GoToButton = () => {
        if (ModuleFE_EMInterface.isAvatarMode() || ModuleFE_EMInterface.isPostDisposition())
            return;
        const contextData = this.state.contextData;
        if (contextData?.protocolData.pathway.type === pathwayType_SingleState)
            return;
        return _jsx(Button, { variant: 'header-button', className: 'go-to', onClick: this.openGoTo, ...openContent.tooltip.top('tooltip__go-to', _jsx(_Fragment, { children: "Use this button or double-click on the state to jump to a specific state" }), { offset: 8 }), children: "Go To" });
    };
    render_Details = () => {
        const contextData = this.state.contextData;
        if (!this.state.showDetails || !contextData)
            return;
        return _jsx("div", { id: 'pop-up__protocol-details', children: _jsx(PopUp_ProtocolDetails, { protocolData: contextData.protocolData, closeDetails: this.hideDetails }) });
    };
}
//# sourceMappingURL=Component_ProtocolInfo.js.map